<form
  class="ap-ml-spacing-5 ap-mr-spacing-5"
  [formGroup]="formDefinition.securityForm"
  novalidate>
  @if (upsertSecurityState.isSpecificAdviceTransaction) {
    <gstar-select-or-add-entity
      [disabled]="rulesEngineForm.inProgress"
      [entity]="formDefinition.entityValue"
      [preserveSelectionOnClientChange]="!!upsertSecurityState.securityId"
      (updateEntity)="updateEntity($event)" />
    <div class="d-flex ap-ml-spacing-4">
      <p>
        {{ 'upsertSecurity.suggestionMessage' | translate }}
      </p>
    </div>
  }
  <div class="row ap-mb-spacing-6">
    <div class="col-6">
      <gstar-textfield
        [disabled]="true"
        [showSuggestion]="false"
        [label]="'upsertSecurity.residencyJurisdictionName' | translate"
        formControlName="residencyJurisdictionName" />
    </div>
    <div class="col-6">
      <gstar-textfield
        [disabled]="true"
        [showSuggestion]="false"
        [label]="'upsertSecurity.entityTypeName' | translate"
        formControlName="entityTypeName" />
    </div>
  </div>
  <ap-field
    [title]="'upsertSecurity.name' | translate"
    [error]="formDefinition.name.touched && !!formDefinition.name.errors">
    <input
      appkit-field
      formControlName="name"
      maxlength="255"
      [disabled]="rulesEngineForm.inProgress" />
    <div class="ap-field-suggestion">
      {{
        'suggestions.charactersRemaining'
          | translate: { count: 255 - formDefinition.name.value.length }
      }}
    </div>

    @if (formDefinition.name.touched) {
      @if (formDefinition.name.hasError('maxlength')) {
        <div class="ap-field-validation-error">
          {{ 'formValidations.maxLength' | translate: { maxCharLength: 255 } }}
        </div>
      }
      @if (formDefinition.name.hasError('pattern')) {
        <div class="ap-field-validation-error">
          {{ 'formValidations.lettersRequired' | translate }}
        </div>
      }
    }
  </ap-field>

  <gstar-investment-jurisdiction-combobox
    [disabled]="rulesEngineForm.inProgress"
    [required]="true"
    [value]="formDefinition.investmentJurisdictionValue"
    [hasInitialValue]="!!upsertSecurityState.securityId"
    (selectInvestmentJurisdiction)="selectInvestmentJurisdiction($event)" />
  @if (
    formDefinition.securityForm.touched &&
    formDefinition.securityForm.errors?.['fieldsMatch']
  ) {
    <div class="ap-field-validation-error">
      {{ 'upsertSecurity.countryValidation' | translate }}
    </div>
  }

  <gstar-security-types-combobox
    [disabled]="rulesEngineForm.inProgress"
    [required]="true"
    [value]="formDefinition.securityTypeValue"
    [allowedSecurityTypeNames]="allowedSecurityTypeNames"
    (selectSecurityType)="selectSecurityType($event)" />

  @if (upsertSecurityState.isSpecificAdviceTransaction) {
    <div class="row ap-mb-spacing-6">
      <div class="col-6">
        <ap-field
          [title]="'upsertSecurity.isinCusip' | translate"
          [error]="
            formDefinition.isinCusip.touched &&
            !!formDefinition.isinCusip.errors
          ">
          <input
            appkit-field
            formControlName="isinCusip"
            maxlength="12"
            [disabled]="rulesEngineForm.inProgress" />

          @if (formDefinition.isinCusip.touched) {
            @if (
              formDefinition.isinCusip.hasError('minlength') ||
              formDefinition.isinCusip.hasError('maxlength')
            ) {
              <div class="ap-field-validation-error">
                {{ 'formValidations.isinLength' | translate }}
              </div>
            }
            @if (formDefinition.isinCusip.hasError('pattern')) {
              <div class="ap-field-validation-error">
                {{ 'formValidations.alphanumeric' | translate }}
              </div>
            }
          }
        </ap-field>
      </div>
      @if (formDefinition.acquisitionDate.value) {
        <div class="col-6">
          <gstar-datepicker
            [disabled]="rulesEngineForm.inProgress"
            [label]="'upsertSecurity.acquireDate' | translate"
            formControlName="acquisitionDate"
            [value]="formDefinition.acquisitionDate.value" />

          @if (formDefinition.acquisitionDate.errors?.['dateRange']) {
            <div class="ap-field-validation-error">
              {{ 'upsertSecurity.acquisitionDateValidation' | translate }}
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="d-flex gap-3 justify-content-end">
    <ap-button
      type="button"
      btnType="secondary"
      [disabled]="rulesEngineForm.inProgress"
      [label]="'shared.cancel' | translate"
      (onClick)="cancel()" />
    <ap-button
      btnType="primary"
      [disabled]="
        formDefinition.securityForm.invalid ||
        rulesEngineForm.inProgress ||
        areJurisdictionsEqual
      "
      [label]="'shared.continue' | translate"
      (onClick)="continue()" />
  </div>
  <div
    class="ap-pl-spacing-6 ap-pr-spacing-8"
    [class.d-none]="hasNoQuestions()">
    <gstar-rules-engine-view
      #rulesEngineForm
      [formValue]="formValue()"
      [transactionType]="upsertSecurityState.transactionType"
      [securityId]="upsertSecurityState.securityId"
      (dynamicFormCompleted)="setFormCompleted($event)" />
    @if (rulesEngineForm.inProgress && isFormNotEmpty) {
      <div class="d-flex justify-content-end ap-mt-spacing-5">
        <ap-button
          btnType="secondary"
          [label]="'shared.cancel' | translate"
          (onClick)="reset()" />
        @if (!upsertSecurityState.securityId) {
          <ap-button
            [disabled]="!isSecurityEnabled()"
            btnType="primary"
            [label]="'shared.save' | translate"
            (onClick)="createSecurity()"
            class="ap-pl-spacing-5" />
        }
        @if (upsertSecurityState.securityId) {
          <ap-button
            [disabled]="!isSecurityEnabled()"
            btnType="primary"
            [label]="'shared.save' | translate"
            (onClick)="updateSecurity()"
            class="ap-pl-spacing-5" />
        }
      </div>
    }
  </div>
</form>
<ap-modal #modal [style]="'width: 540px'" appModalId="modal-warning" title="">
  <p>{{ warningModalMessageKey() | translate }}</p>
</ap-modal>
